import { render } from "./Banner-Layout.vue?vue&type=template&id=1f5fae67"
import script from "./Banner-Layout.vue?vue&type=script&lang=js"
export * from "./Banner-Layout.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__